module.exports = __webpack_public_path__ + "static/media/QAReportIcon.61873770.png";